export default __webpack_public_path__ + "static/media/116-014146-232.94bb3ffa.png";